export default "__VITE_ASSET__8e4887d3__"